import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';

/**
 * Creates Axios instance pre-configured with cache (using axios-cache-adapter).
 * @param {AxiosWithCacheOptions} options Configuration options object
 * @returns {import('axios').AxiosInstance} Pre-configured Axios instance
 */
export function createAxiosWithCache({
  key,
  maxAge
}) {
  const {
    adapter
  } = setupCache({
    key,
    maxAge: maxAge * 60 * 1000,
    exclude: {
      query: false
    } // cache URLs with query parameters

  });
  return axios.create({
    adapter
  });
}
//# sourceMappingURL=createAxiosWithCache.js.map